import React from 'react';
import { INNOVATION } from '../data/mock';

export default function Innovation() {
  return (
    <section id="innovation" className="relative py-24 lg:py-32 bg-[#0F1B2D] overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-30">
        <div className="absolute -top-40 left-1/3 w-[600px] h-[600px] rounded-full bg-[radial-gradient(closest-side,#FF7A2E,transparent_70%)] opacity-25" />
        <div className="absolute bottom-[-200px] right-[-100px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(closest-side,#FFB27A,transparent_70%)] opacity-20" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="max-w-3xl">
          <span className="text-[12.5px] uppercase tracking-[0.22em] font-semibold text-[#FFB27A]">
            {INNOVATION.eyebrow}
          </span>
          <h2
            className="mt-3 text-[36px] sm:text-[44px] lg:text-[52px] leading-[1.05] tracking-[-0.025em] text-white font-semibold"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            {INNOVATION.title}
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {INNOVATION.cards.map((c) => (
            <div
              key={c.step}
              className="group relative rounded-2xl bg-white/5 border border-white/10 hover:bg-white/[0.09] hover:border-[#FF7A2E]/50 backdrop-blur p-7 transition-all duration-300 hover:-translate-y-1"
            >
              <div
                className="text-[13px] font-mono tracking-widest text-[#FFB27A]"
              >
                {c.step}
              </div>
              <h3
                className="mt-6 text-[22px] font-semibold text-white leading-tight"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {c.title}
              </h3>
              <p className="mt-3 text-[14px] leading-[1.65] text-slate-300">{c.copy}</p>
              <div className="mt-6 h-px w-full bg-gradient-to-r from-[#FF7A2E] to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
